"use client";

import { useEffect, useState } from "react";
import Portfolio from "./Portfolio";
import { content } from "../data/siteData";
import { localePath } from "../lib/seo";

const slide = "transition-transform duration-1000 ease-[cubic-bezier(0.76,0,0.24,1)]";

export default function AppView({ locale }) {
  const t = content[locale].landing;
  const [showPortfolio, setShowPortfolio] = useState(false);
  const [animate, setAnimate] = useState(true);

  // Links like /#projects (e.g. from a project page) skip the landing screen.
  useEffect(() => {
    const target = window.location.hash
      ? document.getElementById(window.location.hash.slice(1))
      : null;
    if (!target) return;
    setAnimate(false);
    setShowPortfolio(true);
    target.scrollIntoView();
  }, []);

  return (
    <div className="relative w-full h-screen overflow-hidden bg-[#f5f5f5]">
      {/* Home Section */}
      <div
        className={`absolute top-0 left-0 w-full h-full flex flex-col items-center justify-center gap-8 z-10 ${animate ? slide : ""} ${
          showPortfolio ? "-translate-y-full" : "translate-y-0"
        }`}
      >
        <img
          className="w-[500px] max-sm:w-[300px] h-auto"
          src="/images/LogoName 1.svg"
          alt="Alexandre Fernandes"
          width={505}
          height={246}
          fetchPriority="high"
        />

        <div className="flex flex-col items-center gap-8">
          <p className="font-poppins text-xl text-[#333333] font-normal text-center">
            {t.role}
          </p>

          <button
            onClick={() => setShowPortfolio(true)}
            className="px-8 py-3 rounded-full border border-[#333333] font-poppins text-[#333333]
                       transition-all duration-300 ease-in-out
                       hover:bg-[#333333] hover:text-white hover:border-[#333333] hover:scale-105 hover:cursor-pointer"
          >
            {t.cta}
          </button>
        </div>

        <nav className="absolute bottom-6 flex gap-4 font-poppins font-light text-xs text-[#555555]">
          <a
            href={localePath(locale, "/impressum")}
            className="hover:text-[#333333] transition-colors"
          >
            {content[locale].footer.legal}
          </a>
          <a
            href={localePath(locale, "/datenschutz")}
            className="hover:text-[#333333] transition-colors"
          >
            {content[locale].footer.privacy}
          </a>
        </nav>
      </div>

      {/* Portfolio Section */}
      <div
        className={`absolute top-0 left-0 w-full h-full overflow-y-auto flex flex-col items-center z-20 bg-[#f5f5f5] ${animate ? slide : ""} ${
          showPortfolio ? "translate-y-0" : "translate-y-full"
        }`}
      >
        <Portfolio locale={locale} />
      </div>
    </div>
  );
}
